import parse, {
  attributesToProps,
  domToReact,
  HTMLReactParserOptions,
} from '@hellodarwin/core/web/features/helpers/parse';
import { useMemo } from 'react';
import { MediaAssetProps } from '.';

interface ImageSvgProps extends MediaAssetProps {
  color?: string;
}
const ImageSvg = ({ width, height, style, asset, color }: ImageSvgProps) => {
  const parseOptions: HTMLReactParserOptions = useMemo(
    () => ({
      replace: (domNode: any) => {
        if (domNode.attribs && domNode.name === 'svg') {
          const props = attributesToProps(domNode.attribs);

          return (
            <svg
              {...props}
              width={width ?? props.width}
              height={height ?? props.height}
              style={{ color, ...style }}
            >
              {domToReact(domNode.children)}
            </svg>
          );
        }
      },
    }),
    [width, , height, style, color],
  );

  if (!asset.svgContent) return undefined;

  return parse(asset.svgContent, parseOptions);
};

export default ImageSvg;
